import { SIGUNGU } from "./succession";

export type SidoAtlasEntry = Readonly<{
  code: string;
  name: string;
  aliases: readonly string[];
}>;

export type SigunguAtlasEntry = Readonly<{
  sidoCode: string;
  code: string;
  name: string;
  aliases?: readonly string[];
}>;

export type RegionAtlas = Readonly<{
  sido: readonly SidoAtlasEntry[];
  sigungu: readonly SigunguAtlasEntry[];
}>;

export const SIDO_ALIASES: readonly SidoAtlasEntry[] = Object.freeze([
  { code: "11", name: "서울특별시", aliases: ["서울특별시", "서울시", "서울"] },
  { code: "12", name: "전남광주통합특별시", aliases: ["전남광주통합특별시", "광주광역시", "전라남도", "광주시", "전남", "광주"] },
  { code: "26", name: "부산광역시", aliases: ["부산광역시", "부산시", "부산"] },
  { code: "27", name: "대구광역시", aliases: ["대구광역시", "대구시", "대구"] },
  { code: "28", name: "인천광역시", aliases: ["인천광역시", "인천시", "인천"] },
  { code: "30", name: "대전광역시", aliases: ["대전광역시", "대전시", "대전"] },
  { code: "31", name: "울산광역시", aliases: ["울산광역시", "울산시", "울산"] },
  { code: "36", name: "세종특별자치시", aliases: ["세종특별자치시", "세종시", "세종"] },
  { code: "41", name: "경기도", aliases: ["경기도", "경기"] },
  { code: "43", name: "충청북도", aliases: ["충청북도", "충북"] },
  { code: "44", name: "충청남도", aliases: ["충청남도", "충남"] },
  { code: "45", name: "전북특별자치도", aliases: ["전북특별자치도", "전라북도", "전북"] },
  { code: "47", name: "경상북도", aliases: ["경상북도", "경북"] },
  { code: "48", name: "경상남도", aliases: ["경상남도", "경남"] },
  { code: "50", name: "제주특별자치도", aliases: ["제주특별자치도", "제주도", "제주"] },
  { code: "51", name: "강원특별자치도", aliases: ["강원특별자치도", "강원도", "강원"] },
]);

const sigungu: SigunguAtlasEntry[] = SIGUNGU.map((region) => ({
  sidoCode: region.sidoCode,
  code: region.code,
  name: region.name,
}));

// 자치구가 있는 복합 시는 광역 폴리곤과 별개로 주소 파싱용 현행 코드를 보존한다.
sigungu.push(
  { sidoCode: "41", code: "41111", name: "수원시 장안구" },
  { sidoCode: "41", code: "41113", name: "수원시 권선구" },
  { sidoCode: "41", code: "41115", name: "수원시 팔달구" },
  { sidoCode: "41", code: "41117", name: "수원시 영통구" },
  { sidoCode: "41", code: "41131", name: "성남시 수정구" },
  { sidoCode: "41", code: "41133", name: "성남시 중원구" },
  { sidoCode: "41", code: "41135", name: "성남시 분당구" },
  { sidoCode: "41", code: "41271", name: "안산시 상록구" },
  { sidoCode: "41", code: "41273", name: "안산시 단원구" },
  { sidoCode: "41", code: "41281", name: "고양시 덕양구" },
  { sidoCode: "41", code: "41285", name: "고양시 일산동구" },
  { sidoCode: "41", code: "41287", name: "고양시 일산서구" },
  { sidoCode: "41", code: "41461", name: "용인시 처인구" },
  { sidoCode: "41", code: "41463", name: "용인시 기흥구" },
  { sidoCode: "41", code: "41465", name: "용인시 수지구" },
);

export const DEFAULT_REGION_ATLAS: RegionAtlas = Object.freeze({
  sido: SIDO_ALIASES,
  sigungu: Object.freeze(sigungu),
});
